/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import Loader from "components/custom/Loader";
import { useEffect } from "react";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import { Card, Modal } from "antd";
import MDButton from "components/MDButton";
import { Autocomplete, MenuItem, Select } from "@mui/material";
import { Checkbox } from "antd";
import Button from "@mui/material/Button";
import { useMaterialUIController } from "context";
import { GlobalStyles } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import useApiRequest from "utils/Apirequest";
import { AutoTooltip } from 'utils/Constant';
import { useLocation } from 'react-router-dom';
import { Grid, Typography } from "@mui/material";
import { convertUTCtoDubai } from "utils/Constant";
import TableRefreshButton from "../../components/Loadable/TableRefreshButton";
import axios from "axios";
import { saveAs } from 'file-saver';
import { Drawer, DatePicker } from "antd";
import dayjs from "dayjs";
import LogsDateFilter from "./components/LogsDateFilter";



const { RangePicker } = DatePicker;


const Log = () => {
  const location = useLocation();
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const [mode, setMode] = useState("chargerId");
  const [chargerId, setChargerId] = useState(location?.state || "");
  const [phoneNo, setPhoneNo] = useState("");
  const [rows, setRows] = useState([]);
  const [isLoading1] = useState(false);
  const [chargerDetails, setChargerDetails] = useState({});
  const [locationDetails, setLocationDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const isInitialMount = useRef(true);
  const [selectedSubActions, setSelectedSubActions] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState([
    {
      id: "createdAt",
      desc: true,
    },
  ]);
  const [pageSize, setPageSize] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [chargerIdError, setChargerIdError] = useState("");
  const [chargersID, setChargersID] = useState([]);
  const [chargerIDFetched, setChargerIDFetched] = useState(false);
  const [chargerIDLoading, setChargerIDLoading] = useState(false);
  const [selectedChargerID, setSelectedChargerID] = useState(null);

  const [dateRange, setDateRange] = useState([null, null]);
  const [open, setOpen] = useState(false);

  const disabledDate = (current) => {
    if (!current) return false;

    const today = dayjs().endOf("day");
    const thirtyDaysAgo = dayjs().subtract(30, "day").startOf("day");

    return current < thirtyDaysAgo || current > today;
  };



  const fetchChargers = async () => {
    setChargerIDLoading(true);

    const { data } =
      (await apiRequest(
        "get",
        "charger-locations",
        null,
        {},
        {},
        false
      )) || {};

    if (data?.status || data?.success) {
      const flattenedChargers = data.data.flatMap((location) =>
        (location.chargerInfo || []).map((charger) => ({
          chargerId: charger.name,                // ← store this
          chargerName: charger.chargerName,
          locationName: location.locationName,
          label: `${charger.name} | ${charger.chargerName} | ${location.locationName}`,
        }))
      );

      setChargersID(flattenedChargers);
      setChargerIDFetched(true);
    }

    setChargerIDLoading(false);
  };

  const [dateFilter, setDateFilter] = useState(null);

  const subActionOptions = [
    "BootNotification",
    "DataTransfer",
    "Heartbeat",
    "MeterValues",
    "StatusNotification",
    "StopTransaction",
    "StartTransaction",
    "DiagnosticsStatusNotification",
    "FirmwareStatusNotification",
    "ChangeAvailability",
    "ChangeConfiguration",
    "ClearCache",
    "GetConfiguration",
    "RemoteStartTransaction",
    "RemoteStopTransaction",
    "Reset",
    "UnlockConnector",
    "GetDiagnostics",
    "UpdateFirmware",
    "GetLocalListVersion",
    "SendLocalList",
    "CancelReservation",
    "ReserveNow",
    "ClearChargingProfile",
    "GetCompositeSchedule",
    "SetChargingProfile",
    "TriggerMessage",
    "Authorize"
  ];




  const colorMap = {
    primary: "#e43270",
    info: "#1A73E8",
    success: "#4CAF50",
    warning: "#FF9800",
    error: "#F44336",
    dark: "#212121",
  };
  const apiRequest = useApiRequest();

  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };
  const handleReloadLogs = () => {
    if (!selectedChargerID) {
      enqueueSnackbar("Please select a charger first", { variant: "warning" });
      return;
    }
    getData();
  };


  const memoizedColumns = useMemo(
    () => [
      {
        header: "Timestamp",
        size: 240,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilter: false,
        accessorKey: "timestamp",
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
        align: "center",
        fixed: "true",
      },

      {
        header: "Action",
        size: 190,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: 'center',
        }, accessorKey: "action", align: "center",
        Cell: ({ cell }) => {
          const action = cell.getValue() || ' ';
          return <AutoTooltip maxWidth={150}>{action}</AutoTooltip>;
        }
      },

      {
        header: "Sub - Action",
        size: 240,
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },

        accessorFn: (row) =>
          Array.isArray(row.message) ? row.message[2] : null,

        Filter: ({ column }) => (
          <Select
            multiple
            onChange={(e) => {
              handleSelectedSubActionsChange(e.target.value);
            }}
            value={selectedSubActions}
            displayEmpty
            fullWidth
            variant="standard"
            size="small"
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>All</em>;
              }
              return selected.join(", ");
            }}
            sx={{ m: 1, minWidth: 120, maxHeight: "200px" }}
          >
            {subActionOptions.map((option) => (
              <MenuItem key={option} value={option}>
                <Checkbox checked={selectedSubActions.indexOf(option) > -1} />
                {option}
              </MenuItem>
            ))}
          </Select>
        ),

        Cell: ({ row }) => {
          const messages = row.original.message;
          if (!Array.isArray(messages)) return "N/A";

          const value = messages[2];

          const displayValue =
            typeof value === "object" && value !== null
              ? JSON.stringify(value, null, 2)
              : value || "N/A";

          return (
            <AutoTooltip maxWidth={300}>
              {displayValue}
            </AutoTooltip>
          );
        },
      },
      {
        header: "Message",
        accessorKey: "message",
        size: 400,

        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        enableColumnFilter: true,

        filterFn: (row, columnId, filterValue) => {
          const messages = row.getValue(columnId);
          if (!Array.isArray(messages)) return false;

          const slicedMessages = messages.slice(2);
          const target = slicedMessages[1];

          const text =
            typeof target === "object" ? JSON.stringify(target) : target || "";

          return text.toLowerCase().includes(filterValue.toLowerCase());
        },

        Cell: ({ cell, table }) => {
          const messages = cell.getValue();
          if (!Array.isArray(messages)) return "N/A";

          const slicedMessages = messages.slice(2);
          let value = slicedMessages[1] || "N/A";

          if (typeof value === "object") {
            value = JSON.stringify(value);
          }

          const filterValue =
            table.getState().columnFilters.find((f) => f.id === "message")?.value || "";

          // If no filter → simple clipped AutoTooltip
          if (!filterValue || typeof value !== "string") {
            return <AutoTooltip maxWidth={250}>{value}</AutoTooltip>;
          }

          // If filtered → highlight parts but still use AutoTooltip for ellipsis+tooltip
          const regex = new RegExp(`(${filterValue})`, "gi");
          const parts = value.split(regex);

          return (
            <AutoTooltip maxWidth={250}>
              <span style={{ whiteSpace: "nowrap" }}>
                {parts.map((part, index) =>
                  part.toLowerCase() === filterValue.toLowerCase() ? (
                    <span
                      key={index}
                      style={{ backgroundColor: "rgb(253, 209, 153)" }}
                    >
                      {part}
                    </span>
                  ) : (
                    <span key={index}>{part}</span>
                  )
                )}
              </span>
            </AutoTooltip>
          );
        },

      },

      {
        header: "createdAt",
        accessorKey: "createdAt",
        size: 220,
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "updatedAt",
        accessorKey: "updatedAt",
        size: 220,
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
    ],
    [selectedSubActions]
  );

  const handleDownloadExcel1 = async () => {

    const payload = {
      "collection": "ChargerLog",
      "filters": {
        "chargerId": selectedChargerID,
        "action": selectedSubActions
      },
      "dateRange": {
        "from": dateRange?.from,
        "to": dateRange?.to
      },
      "columns": [
        "chargerId",     // ID of charger
        "action",        // Action performed
        "timestamp",     // Event timestamp
        "message",       // Message/details (can be JSON)
      ],
      "fileName": "log_export"
    }

    try {
      // Use axios directly and set the responseType to 'blob'
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}reports/export-report`,
        payload,
        {
          withCredentials: true,
          responseType: 'blob', // This tells axios to handle the response as a file
        }
      );

      // The 'response.data' is now the file blob itself
      const blob = response.data;
      const fileName = "log_export.xlsx";

      // Use 'file-saver' to trigger the download
      saveAs(blob, fileName);

      enqueueSnackbar("Download started successfully!", { variant: 'success' });

    } catch (error) {
      console.error("Failed to download report:", error);
      enqueueSnackbar("Failed to download report.", { variant: 'error' });
    }
  };



  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  const getData = async () => {
    if (!selectedChargerID) {
      setRows([]);
      setTotalRows(0);
      return;
    }
    console.log("API called");
    setIsLoading(true);

    const params = new URLSearchParams();

    params.set("page", page + 1);
    params.set("limit", pageSize);
    params.set("sortField", sorting[0]?.id || "createdAt");
    params.set("sortOrder", sorting[0]?.desc ? "desc" : "asc");

    //  ALWAYS send search
    params.set("search", searchText?.trim() || "");

    //  ALWAYS send searchMessage
    params.set(
      "searchMessage",
      selectedSubActions.length ? selectedSubActions.join(",") : ""
    );

    //  DATE FILTER (preset OR custom)
    if (dateFilter?.preset && dateFilter.preset !== "custom") {
      params.set("datefilter", dateFilter.preset);
    } else if (dateFilter?.from && dateFilter?.to) {
      params.set("datefilter", "custom");
      params.set("fromDate", dateFilter.from);
      params.set("toDate", dateFilter.to);
    }

    try {
      const { data } =
        (await apiRequest(
          "get",
          `logs/${selectedChargerID}?${params.toString()}`,
          null,
          {},
          {}
        )) || {};

      if (data?.status) {
        setRows(data.data.logs);
        setTotalRows(data.pagination.totalRecords);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Failed to fetch logs", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedChargerID) return;

    const todayFrom = dayjs().startOf("day").format("YYYY-MM-DD");
    const todayTo = dayjs().endOf("day").format("YYYY-MM-DD");

    setDateFilter({
      from: todayFrom,
      to: todayTo,
      preset: "today",
    });

    setPage(0);
  }, [selectedChargerID]);

  const handleSearchChange = (event) => {
    setSearchText(event);
    setPage(0);
  };

  const handleSelectedSubActionsChange = (newValues) => {
    setSelectedSubActions(newValues);
    setPage(0);
  };

  let dateQuery = "";
  if (dateFilter?.from && dateFilter?.to) {
    dateQuery = `&from=${dateFilter.from}&to=${dateFilter.to}`;
  }


  useEffect(() => {
    if (!selectedChargerID) return;

    if (!isInitialMount.current) {
      getData();
    } else {
      isInitialMount.current = false;
    }
  }, [page, pageSize, sorting, searchText, selectedSubActions, dateFilter, selectedChargerID]);

  const Reset = (event) => {
    event.preventDefault();
    setSelectedChargerID("");
    setChargerId("");
    setPhoneNo("");
    setChargerDetails({});
    setRows([]);
    setLocationDetails({});
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />

        {/* toggle Navbar Code  */}
        {isLoading ? (
          <Loader />
        ) : (
          <MDBox
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "0.5rem",
              marginTop: "1rem",
              width: "100vw",
              maxWidth: "100%",
              overflowX: "hidden",
              flexDirection: window.innerWidth <= 768 ? "column" : "row",
            }}
          >
            <Card
              style={{
                width: "100%",
                backgroundColor: darkMode ? "rgb(32,41,64)" : "#ffff",
                color: darkMode ? "#fff" : "#0000",
                border: "none",
              }}
            >



              <Autocomplete
                options={chargersID}
                loading={chargerIDLoading}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) =>
                  option.chargerId === value
                }
                value={
                  chargersID.find(
                    (item) => item.chargerId === selectedChargerID
                  ) || null
                }
                onChange={(event, newValue) => {
                  setSelectedChargerID(newValue ? newValue.chargerId : null);
                }}
                onOpen={() => {
                  if (!chargerIDFetched) fetchChargers();
                }}
                sx={{ minWidth: 320, flexGrow: 1, marginTop: 2 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Charger"
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: 44, }, "& .MuiInputBase-input": { padding: "10px", }, }}
                  />
                )}
              />


              <MDBox
                my={2}
                style={{
                  gap: "1rem",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              ></MDBox>

              <MDBox
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                }}
                marginTop={2}
              >
                <Button variant="text" onClick={Reset}>
                  Reset
                </Button>
                <MDButton
                  variant="gradient"
                  color={sidenavColor}
                  onClick={getData}
                >
                  Get Data
                </MDButton>
              </MDBox>
            </Card>

            {Object.keys(chargerDetails).length > 0 && (
              <Card
                style={{
                  width: window.innerWidth <= 768 ? "100%" : "40%",
                  backgroundColor: darkMode ? "rgb(32,41,64)" : "#ffff",
                  color: darkMode ? "#fff" : "#0000",
                  border: "none",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={4}
                  display="flex"
                  justifyContent="flex-end"
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Card
                        style={{
                          backgroundColor: darkMode
                            ? "rgb(52, 71, 103)"
                            : "#F0F0F0",
                          border: "none",
                        }}
                      >
                        <Typography
                          style={{ color: darkMode ? "#fff" : "#000" }}
                          variant="h4"
                          component="h1"
                          gutterBottom
                        >
                          {chargerDetails.name}
                        </Typography>
                        <Typography
                          style={{ color: darkMode ? "#fff" : "#000" }}
                          variant="subtitle1"
                          sx={{ lineHeight: "36px" }}
                        >
                          {chargerDetails.type} |{" "}
                          {chargerDetails.energyConsumptions}
                        </Typography>
                        <Typography
                          style={{ color: darkMode ? "#fff" : "#000" }}
                          variant="subtitle1"
                          sx={{ lineHeight: "36px" }}
                        >
                          Cost Per Unit - {chargerDetails.costPerUnit.currency}{" "}
                          {chargerDetails.costPerUnit.amount * 1000}
                        </Typography>
                        <Typography
                          style={{ color: darkMode ? "#fff" : "#000" }}
                          variant="subtitle1"
                          sx={{ lineHeight: "36px" }}
                        >
                          Power Output: {chargerDetails.powerOutput}
                        </Typography>
                        <Typography
                          style={{ color: darkMode ? "#fff" : "#000" }}
                          variant="subtitle1"
                          sx={{ lineHeight: "36px" }}
                        >
                          {locationDetails.locationName} |{" "}
                          {locationDetails.locationType}
                        </Typography>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            )}
          </MDBox>
        )}

        {/* </div> */}
        <MDBox mt={8}>
          <Card
            className="tableCard"
            style={{
              backgroundColor: darkMode ? "rgb(32,41,64)" : "#ffff",
              color: darkMode ? "#fff" : "#0000",
              border: "none",
            }}
            bodyStyle={{
              padding: 0,
            }}
          >
            <MDBox
              mx={2}
              mt={-3}
              py={1}
              px={2}
              variant="gradient"
              bgColor={sidenavColor}
              borderRadius="lg"
              coloredShadow={sidenavColor}
            >
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Charging Activity Logs
                </MDTypography>
                <MDBox
                  className="admin_btnsHeaderCont"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <MDButton
                    onClick={() => setOpen(true)}
                    variant="outlined"
                    color="white"
                    disabled={!rows || rows.length === 0}
                  >
                    Export Logs
                  </MDButton>
                  <TableRefreshButton
                    onRefresh={handleReloadLogs}
                    loading={isLoading}
                    tooltip="Reload Logs"
                  />
                </MDBox>

              </Grid>

            </MDBox>

            {isLoading1 ? (
              <Loader />
            ) : (
              <>
                <MDBox my={2} mx={2}>
                  <LogsDateFilter
                    disabled={!selectedChargerID}
                    onChange={(range) => {
                      setDateFilter(range);
                      setPage(0);
                    }}
                  />

                </MDBox>
                <CustomMaterialTablePage
                  columns={memoizedColumns}
                  data={rows}
                  darkMode={darkMode}
                  manualPagination={true}
                  manualFiltering={true}
                  rowCount={totalRows}
                  paginationChange={(newPage) => setPagination(newPage)}
                  soringChange={handleSortingChange}
                  page={page}
                  pagesize={pageSize}
                  pagination={pagination}
                  sorting={sorting}
                  searchChange={handleSearchChange}
                />
              </>)}
            {/* </Grid>
              </Grid>
            </MDBox> */}
          </Card>
        </MDBox>
        <Modal
          title="Select Date Range"
          open={open}
          onCancel={() => setOpen(false)}
          footer={[
            <Button key="cancel" onClick={() => setOpen(false)}>
              Cancel
            </Button>,
            <Button
              key="ok"
              type="primary"
              disabled={!dateRange}
              onClick={() => {
                handleDownloadExcel1();
                setOpen(false);
              }}
            >
              Download
            </Button>,
          ]}
        >
          <RangePicker
            style={{ width: "100%" }}
            disabledDate={disabledDate}
            onChange={(dates) => {
              setDateRange({
                from: dates[0].format("YYYY-MM-DD"),
                to: dates[1].format("YYYY-MM-DD"),
              });
            }}
          />
        </Modal>
      </DashboardLayout>
      {darkMode && (
        <GlobalStyles
          styles={{
            ".ant-picker-input input::placeholder": {
              color: "#ffffff !important",
              opacity: 1,
            },
            ".ant-picker-suffix": {
              color: "#ffffff !important",
            },
          }}
        />
      )}
    </>
  );
};

export default Log;